import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPartner } from 'src/app/pages/partners/models/partner.interface';
import { PartnerService } from 'src/app/pages/partners/services/partner.service';
import { ERoleAdminString } from 'src/app/shared/data/role.enum';
import { ModalConfirmacaoService } from 'src/app/shared/services/modal-confirmacao.service';
import { ToastService } from 'src/app/shared/services/toast.service';

@Component({
  selector: 'app-list-partners-settings',
  templateUrl: './list-partners-settings.component.html',
  styleUrls: ['./list-partners-settings.component.scss']
})
export class ListPartnersSettingsComponent {
  ERoleAdminString = ERoleAdminString;
  @Input() partners: IPartner[] = [];
  @Output() mudouPagina = new EventEmitter<number>();
  @Output() mudouTamanhoPagina = new EventEmitter<number>();
  @Output() recarregarListagem = new EventEmitter();
  @Input() dadosPaginacao: {
    paginaSelecionada: number;
    tamanhoPagina: number;
    totalPaginas: number;
    itensTotal: number;
  } = {
      paginaSelecionada: 0,
      tamanhoPagina: 10,
      totalPaginas: 0,
      itensTotal: 0
    };

  constructor(
    private readonly partnerService: PartnerService,
    private readonly toastService: ToastService,
    private readonly modalConfirmacao: ModalConfirmacaoService
  ) { }

  public toogleParceiroStatus(partnerId: string, status: boolean): void {
    const textoStatus = status ? 'desativar' : 'ativar';

    this.modalConfirmacao
      .abrirModalConfirmacao({
        mensagem: `Tem certeza que deseja ${textoStatus} o parceiro?`
      })
      .subscribe((resposta) => {
        if (!resposta) return;

        if (status) {
          this.partnerService.desativarParceiro(partnerId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        } else {
          this.partnerService.ativarParceiro(partnerId).subscribe((resposta) => {
            if (resposta.messages && resposta.messages.length > 0) {
              this.toastService.toast(resposta.messages);
            }

            if (resposta.isSucceed) {
              this.recarregarListagem.emit();
            }
          });
        }
      });
  }
}